module.exports = __webpack_public_path__ + "static/media/WebScape_new.6d75f437.png";